export const colors = {
  'action-primary': '#5c7777',
  'action-primary-hovered': '#405859',
  'action-primary-pressed': '#2f4344',
  'action-primary-subdued': '#f7f8f8',
  'action-primary-subdued-hovered': '#f0f3f3',
  'action-primary-subdued-pressed': '#e2e8e8',
  'action-primary-disabled': '#fff8e5',
  'action-neutral': '#FFFFFF',
  'action-neutral-hovered': '#fff8e5',
  'action-neutral-pressed': '#faf3e0',
  'action-neutral-subdued': '#faf3e0',
  'action-neutral-subdued-hovered': '#ede6d4',
  'action-neutral-subdued-pressed': '#dad3c2',
  'action-neutral-disabled': '#FFFFFF',
  'action-destructive': '#d83028',
  'action-destructive-hovered': '#a71613',
  'action-destructive-pressed': '#840a08',
  'action-destructive-subdued': '#fff5f3',
  'action-destructive-subdued-hovered': '#fff0ec',
  'action-destructive-subdued-pressed': '#ffe0da',
  'action-destructive-disabled': '#faf3e0',
  background: '#faf3e0',
  'background-hovered': '#ede6d4',
  'background-pressed': '#dad3c2',
  'background-selected': '#dad3c2',
  'background-backdrop': '#00000080',
  'background-overlay': '#ffffff80',
  'background-divider': '#a7a193',
  content: '#070605',
  'content-subdued': '#56534b',
  'content-muted': '#767267',
  'content-hovered': '#181714',
  'content-pressed': '#56534b',
  'content-disabled': '#a7a193',
  'content-on-positive': '#004b22',
  'content-on-attention': '#663200',
  'content-on-highlight': '#04255b',
  'content-on-negative': '#840a08',
  'content-on-negative-hovered': '#580202',
  'content-on-negative-pressed': '#380101',
  'content-primary': '#1c2a2a',
  'content-on-primary': '#FFFFFF',
  'content-on-inverse': '#fff8e5',
  'content-on-destructive': '#FFFFFF',
  'content-on-interactive': '#FFFFFF',
  'content-on-background': '#070605',
  'content-on-background-subdued': '#56534b',
  'content-on-background-hovered': '#181714',
  'content-on-background-pressed': '#56534b',
  'content-on-background-disabled': '#a7a193',
  interactive: '#405859',
  'interactive-hovered': '#2f4344',
  'interactive-pressed': '#1c2a2a',
  'interactive-disabled': '#fff8e5',
  'interactive-destructive': '#d83028',
  'interactive-destructive-hovered': '#a71613',
  'interactive-destructive-pressed': '#840a08',
  'interactive-destructive-disabled': '#fff8e5',
  topbar: '#FFFFFF',
  'topbar-subdued': '#faf3e0',
  'content-on-topbar': '#070605',
  'line-on-topbar': '#dad3c2',
  'line-on-topbar-pressed': '#767267',
  link: '#814400',
  'link-hovered': '#663200',
  'link-pressed': '#431e00',
  line: '#dad3c2',
  'line-subdued': '#ede6d4',
  'line-hovered': '#a7a193',
  'line-pressed': '#767267',
  'line-selected': '#56534b',
  'line-disabled': '#ede6d4',
  'line-transparent': '#0000001a',
  'line-positive': '#00612f',
  'line-positive-subdued': '#90e6af',
  'line-highlight': '#1650ab',
  'line-highlight-subdued': '#b4d8ff',
  'line-negative': '#a71613',
  'line-negative-subdued': '#ffc7bc',
  'line-negative-disabled': '#ffe0da',
  'line-attention': '#844200',
  'line-attention-subdued': '#ffcb89',
  focused: '#405859',
  skeleton: '#ede6d4',
  surface: '#FFFFFF',
  'surface-subdued': '#faf3e0',
  'surface-hovered': '#faf3e0',
  'surface-subdued-hovered': '#ede6d4',
  'surface-pressed': '#ede6d4',
  'surface-disabled': '#fff8e5',
  'surface-selected': '#f7f8f8',
  'surface-selected-hovered': '#f0f3f3',
  'surface-selected-pressed': '#e2e8e8',
  'surface-attention': '#ffe2bb',
  'surface-attention-subdued': '#fff7ed',
  'surface-negative': '#ffe0da',
  'surface-negative-subdued': '#fff5f3',
  'surface-negative-subdued-hovered': '#fff0ec',
  'surface-negative-subdued-pressed': '#ffe0da',
  'surface-positive': '#c1f2d0',
  'surface-positive-subdued': '#f2fbf5',
  'surface-highlight': '#d3e8ff',
  'surface-highlight-subdued': '#f4f9ff',
  'surface-highlight-subdued-hovered': '#e9f3ff',
  'surface-highlight-subdued-pressed': '#d3e8ff',
  'surface-neutral': '#ede6d4',
  'surface-neutral-subdued': '#fff8e5',
  'surface-inverse': '#181714',
  'decorative-surface-1': '#FFC96B',
  'decorative-surface-1-subdued': '#FFE4B5',
  'decorative-content-1': '#7E5700',
  'decorative-surface-2': '#FFC4B0',
  'decorative-surface-2-subdued': '#FFE1D7',
  'decorative-content-2': '#AF294E',
  'decorative-surface-3': '#92E6B5',
  'decorative-surface-3-subdued': '#C9F3DA',
  'decorative-content-3': '#006D41',
  'decorative-surface-4': '#91E0D6',
  'decorative-surface-4-subdued': '#C8EFEB',
  'decorative-content-4': '#006A68',
  'decorative-surface-5': '#FDC9D0',
  'decorative-surface-5-subdued': '#FEE4E7',
  'decorative-content-5': '#AE2B4C',
  'decorative-surface-6': '#7CD4FD',
  'decorative-surface-6-subdued': '#BDE9FE',
  'decorative-content-6': '#065986',
  'decorative-surface-7': '#BDB4FE',
  'decorative-surface-7-subdued': '#DED9FF',
  'decorative-content-7': '#4A1FB8',
}
